
export const NAVIGATIONS_UBI = [
  {
    name: 'Dashboard',
    icon: '../../assets/svg/space_dashboard_FILL1_wght700_GRAD0_opsz24.svg',
    link: 'admin/view-dashboard',
    isSelected: false
  },
  
  {
    name: 'Consent Status',
    icon: '../../assets/svg/white/baseline_how_to_reg_white_24dp.png',
    submenu: [
      {name:"Consent 'YES'", link:'view-consent-yes',isSubMenuSelected:false},
      {name:"Consent 'NO'", link: 'view-consent-no',isSubMenuSelected:false},
      {name:"Consent 'DNR'", link:'view-consent-dnr',isSubMenuSelected:false},

    ],
    isSubmenuVisible: false,
    isSelected: false
  },
  {
    name: 'Land Record Updation',
    icon: '../../assets/svg/white/baseline_vrpano_white_24dp.png',
    link: 'admin/view-landrecordupdatation',
    isSelected: false
  },
  {
    name: 'Renewal Inbox',
    icon: '../../assets/svg/white/baseline_email_white_24dp.png',
    submenu: [
      {name:"Success Cases", link:'renewal-success',isSubMenuSelected:false},
      // {name:"Branch Processing", link: 'renewal-processing',isSubMenuSelected:false},
      {name:"Failure Box", link:'renewal-failure',isSubMenuSelected:false},

    ],
    isSubmenuVisible: false,
    isSelected: false
  },
  {
    name: 'Digitally Renewed',
    icon: '../../assets/svg/white/baseline_devices_white_24dp.png',
    link: 'admin/view-cbs-approved',
    isSelected: false
  },
  {
    name: 'MIS',
    icon: '../../assets/svg/white/baseline_leaderboard_white_24dp.png',
    link: 'admin/mis',
    isSelected: false
  },
  // {
  //   name: 'Lead Box',
  //   icon: '../../assets/svg/white/baseline_groups_2_white_24dp.png',
  //   link: 'admin/leadbox',
  //   isSelected: false
  // },
  {
    name: 'Utilities',
    icon: '../../assets/svg/settings_account_box_FILL1_wght700_GRAD0_opsz24.svg',
    link: 'admin/utilities',
    isSelected: false
  },
];

export const NAVIGATIONS_UBI_NO_UTIL = [
  {
    name: 'Dashboard',
    icon: '../../assets/svg/space_dashboard_FILL1_wght700_GRAD0_opsz24.svg',
    link: 'admin/view-dashboard',
    isSelected: false
  },
  
  {
    name: 'Consent Status',
    icon: '../../assets/svg/white/baseline_how_to_reg_white_24dp.png',
    submenu: [
      {name:"Consent 'YES'", link:'view-consent-yes',isSubMenuSelected:false},
      {name:"Consent 'NO'", link: 'view-consent-no',isSubMenuSelected:false},
      {name:"Consent 'DNR'", link:'view-consent-dnr',isSubMenuSelected:false},

    ],
    isSubmenuVisible: false,
    isSelected: false
  },
  {
    name: 'Land Record Updation',
    icon: '../../assets/svg/white/baseline_vrpano_white_24dp.png',
    link: 'admin/view-landrecordupdatation',
    isSelected: false
  },
  {
    name: 'Renewal Inbox',
    icon: '../../assets/svg/white/baseline_email_white_24dp.png',
    submenu: [
      {name:"Success Cases", link:'renewal-success',isSubMenuSelected:false},
      // {name:"Branch Processing", link: 'renewal-processing',isSubMenuSelected:false},
      {name:"Failure Box", link:'renewal-failure',isSubMenuSelected:false},

    ],
    isSubmenuVisible: false,
    isSelected: false
  },
  {
    name: 'Digitally Renewed',
    icon: '../../assets/svg/white/baseline_devices_white_24dp.png',
    link: 'admin/view-cbs-approved',
    isSelected: false
  },
  {
    name: 'MIS',
    icon: '../../assets/svg/white/baseline_leaderboard_white_24dp.png',
    link: 'admin/mis',
    isSelected: false
  },
  // {
  //   name: 'Lead Box',
  //   icon: '../../assets/svg/white/baseline_groups_2_white_24dp.png',
  //   link: 'admin/leadbox',
  //   isSelected: false
  // },
];

